export default __webpack_public_path__ + "static/media/CreditEntry_Dark2.25e04fe1.svg";